var map = {
	"../pages/authentication/lock/lock.module": [
		"./src/app/pages/authentication/lock/lock.module.ts",
		"pages-authentication-lock-lock-module"
	],
	"../pages/authentication/login/login.module": [
		"./src/app/pages/authentication/login/login.module.ts",
		"common",
		"pages-authentication-login-login-module"
	],
	"../pages/authentication/terms/tc.module": [
		"./src/app/pages/authentication/terms/tc.module.ts",
		"pages-authentication-terms-tc-module"
	],
	"../pages/dashboards/dashboards.module": [
		"./src/app/pages/dashboards/dashboards.module.ts",
		"pages-dashboards-dashboards-module"
	],
	"../pages/invoice-pay-status/invoice-failed.module": [
		"./src/app/pages/invoice-pay-status/invoice-failed.module.ts",
		"pages-invoice-pay-status-invoice-failed-module~pages-invoice-pay-status-invoice-success-module~pages~3486a65a",
		"common",
		"pages-invoice-pay-status-invoice-failed-module"
	],
	"../pages/invoice-pay-status/invoice-success.module": [
		"./src/app/pages/invoice-pay-status/invoice-success.module.ts",
		"pages-invoice-pay-status-invoice-failed-module~pages-invoice-pay-status-invoice-success-module~pages~3486a65a",
		"common",
		"pages-invoice-pay-status-invoice-success-module"
	],
	"../pages/orders/create-new-order/create-order.module": [
		"./src/app/pages/orders/create-new-order/create-order.module.ts",
		"pages-invoice-pay-status-invoice-failed-module~pages-invoice-pay-status-invoice-success-module~pages~3486a65a",
		"common",
		"pages-orders-create-new-order-create-order-module"
	],
	"../pages/orders/list/orders-list.module": [
		"./src/app/pages/orders/list/orders-list.module.ts",
		"pages-invoice-pay-status-invoice-failed-module~pages-invoice-pay-status-invoice-success-module~pages~3486a65a",
		"common",
		"pages-orders-list-orders-list-module"
	],
	"../pages/orders/price-calculator/price-calculator.module": [
		"./src/app/pages/orders/price-calculator/price-calculator.module.ts",
		"pages-invoice-pay-status-invoice-failed-module~pages-invoice-pay-status-invoice-success-module~pages~3486a65a",
		"common",
		"pages-orders-price-calculator-price-calculator-module"
	],
	"../pages/profile/profile.module": [
		"./src/app/pages/profile/profile.module.ts",
		"pages-profile-profile-module"
	],
	"../pages/remmitance/remmitance-list.module": [
		"./src/app/pages/remmitance/remmitance-list.module.ts",
		"pages-invoice-pay-status-invoice-failed-module~pages-invoice-pay-status-invoice-success-module~pages~3486a65a",
		"common",
		"pages-remmitance-remmitance-list-module"
	],
	"../pages/seller-profile/seller-profile-add.module": [
		"./src/app/pages/seller-profile/seller-profile-add.module.ts",
		"common",
		"pages-seller-profile-seller-profile-add-module"
	],
	"../pages/shipping-credit/shipping-credit.module": [
		"./src/app/pages/shipping-credit/shipping-credit.module.ts",
		"common",
		"pages-shipping-credit-shipping-credit-module"
	],
	"../pages/statements/statements-list.module": [
		"./src/app/pages/statements/statements-list.module.ts",
		"pages-invoice-pay-status-invoice-failed-module~pages-invoice-pay-status-invoice-success-module~pages~3486a65a",
		"common",
		"pages-statements-statements-list-module"
	],
	"../pages/subscription/subscription.module": [
		"./src/app/pages/subscription/subscription.module.ts",
		"common",
		"pages-subscription-subscription-module"
	],
	"../pages/weightdiscrepency/statements-list.module": [
		"./src/app/pages/weightdiscrepency/statements-list.module.ts",
		"pages-invoice-pay-status-invoice-failed-module~pages-invoice-pay-status-invoice-success-module~pages~3486a65a",
		"common",
		"pages-weightdiscrepency-statements-list-module"
	],
	"./layout/layout.module": [
		"./src/app/layout/layout.module.ts",
		"common",
		"layout-layout-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;